// extracted by mini-css-extract-plugin
export default {"siderContainer":"src-layout-Components-SiderHorizental-css__siderContainer--ytzOH"};